var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{class:_vm.styles,attrs:{"fluid":""}},[_c('fieldset',{attrs:{"disabled":_vm.isBusy}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }